import type { PolicyTopicData } from "@/contexts/WizardContext";

// Helper to get topic completion status
export const getTopicStatus = (topic: PolicyTopicData): "not-started" | "in-progress" | "complete" => {
  if (topic.policyExists === null || topic.policyExists === undefined) return "not-started";
  if (topic.policyExists === "no" || topic.policyExists === "unknown") return "complete";
  if (topic.policyExists === "yes") {
    if (topic.publiclyAvailable === "yes") {
      if (!topic.publicUrl) return "in-progress";
    }
    if (topic.hasTargets === "yes") {
      if (!topic.targets || topic.targets.length === 0) return "in-progress";
      const hasValidTargets = topic.targets.every(t => t.targetName && t.metric && t.targetYear && t.targetValue !== undefined);
      if (!hasValidTargets) return "in-progress";
    }
    if (topic.publiclyAvailable === null || topic.hasTargets === null) return "in-progress";
    return "complete";
  }
  return "in-progress";
};
